import createCrudModule from 'vuex-crud'
import api from 'utils/api'

export default createCrudModule({
  client: api.client,
  resource: 'invoiceProcessors',
  parseSingle: res => res.data,
  customUrlFn: (id, params) => `/projects/${params.project_id}/invoices/${params.invoice_id}/processor`,
  only: [
    'FETCH_SINGLE',
    'CREATE'
  ],
});